export interface MembershipBenefitsExplainerSectionProps {
  overline: string
  headline: string
  subheading: string
  body: React.ReactNode
}

const MembershipBenefitsExplainerSection = ({
  overline,
  headline,
  subheading,
  body,
}: MembershipBenefitsExplainerSectionProps) => (
  <div
    className="flex flex-col justify-center"
    data-testid="membership-benefits-explainer-section"
  >
    <div
      className="font-sm text-overline mb-6"
      data-testid="membership-benefits-explainer-section-overline"
    >
      {overline}
    </div>

    <h3
      className="text-xl font-semibold mb-6"
      data-testid="membership-benefits-explainer-section-headline"
    >
      {headline}
    </h3>

    <h2
      className="text-2xl font-medium mb-6"
      data-testid="membership-benefits-explainer-section-subheading"
    >
      {subheading}
    </h2>

    {body}
  </div>
)

export default MembershipBenefitsExplainerSection
